// Ajudas de DOM. O HTML não tem texto: cada elemento traz data-i18n (textContent),
// data-i18n-placeholder, data-i18n-alt ou data-i18n-aria-label com a chave de en.ts.
import { en, type StringKey, t } from "./strings/en";

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`elemento #${id} ausente`);
  return el as T;
}

function key(raw: string): StringKey {
  if (!(raw in en)) throw new Error(`chave de texto desconhecida: ${raw}`);
  return raw as StringKey;
}

// Sem um ouvinte de touchstart, o Safari do iPhone não aplica :active e o botão só reage ao soltar.
const noop = (): void => {};

export function applyStrings(root: ParentNode = document): void {
  if (root === document) document.addEventListener("touchstart", noop, { passive: true });
  const attrs: [string, string][] = [
    ["data-i18n-placeholder", "placeholder"],
    ["data-i18n-alt", "alt"],
    ["data-i18n-aria-label", "aria-label"],
  ];
  root.querySelectorAll<HTMLElement>("[data-i18n]").forEach((el) => {
    el.textContent = t(key(el.dataset.i18n!));
  });
  for (const [dataAttr, attr] of attrs) {
    root.querySelectorAll<HTMLElement>(`[${dataAttr}]`).forEach((el) => {
      el.setAttribute(attr, t(key(el.getAttribute(dataAttr)!)));
    });
  }
}

export function show(el: HTMLElement, visible: boolean): void {
  el.hidden = !visible;
}

// Mostra um painel e esconde os irmãos marcados com data-panel.
export function showPanel(id: string): void {
  document.querySelectorAll<HTMLElement>("[data-panel]").forEach((p) => {
    p.hidden = p.id !== id;
  });
}

export function setMessage(el: HTMLElement, text: string | null): void {
  el.textContent = text ?? "";
  el.hidden = text === null;
}

export function setBusy(button: HTMLButtonElement, busy: boolean): void {
  button.disabled = busy;
  button.setAttribute("aria-busy", String(busy));
}
